import type { CSSProperties, ReactNode } from "react";

/** CSS-driven entrance so content is always rendered, even if JS animation stalls. */
export function Reveal({
  children,
  delay = 0,
  className
}: {
  children: ReactNode;
  delay?: number;
  className?: string;
}) {
  return <div className={`snak-reveal ${className ?? ""}`} style={{
    animationDelay: `${delay}s`
  } as CSSProperties} data-id="element-219" data-mp="2246re9ozl6s">
      {children}
    </div>;
}